export const environment = {
    production: true,
    hmr: false,
    apiUrl: 'https://api.edockets.cdr.alncorp.com/api',
    centralAppBaseUri: 'https://apps.cdr.alncorp.com',
    efilingBaseUri: 'http://efiling.cdr.alncorp.com',
    administrationUri: 'https://admin.cdr.alncorp.com/home',
    myProfileUri: 'https://identity.cdr.alncorp.com/user',
    changePassword: 'https://identity.cdr.alncorp.com/manage/changepassword',
    landingPage: 'login',
    AlnIdentity: {
        stsUrl: 'https://identity.cdr.alncorp.com/',
        clientId: 'eDockets',
        scope: 'openid profile email edapi:access:full',
        logoutUrl: 'https://identity.cdr.alncorp.com/account/ExternalLogout?client=eDockets',
        myProfileUri: 'https://identity.cdr.alncorp.com/user',
    },
    AderantIdentity: {
        stsUrl: 'https://aderantidentitydev.b2clogin.com/aderantidentitydev.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN_DEV',
        clientId: '1158ccbd-9825-4149-836b-d6026fbcc25a',
        scope: 'openid',
        logoutUrl: ''
    },
    redirectRoute: '/appgateway/home',
    silentRenewRoute: 'silent-renew.html',
    logConsoleDebugActive: true,
    centralAPIBaseUri: 'https://api.apps.cdr.alncorp.com',
    postLoginUrl: '/appgateway/home',
    idleTimeOut: '21600',
    messageTimeOut: '60',
    adminApiUrl: 'https://edadminapi.cdr.alncorp.com/api/',
    signalRApiUrl: 'https://signalr.api.cdr.alncorp.com/milana',
    customMessageIntervalInSeconds: 30,
    netDocsRedirectUrlPath: 'cm/netdocuments',
    cutomMessagesApiUrl: 'https://custom-messages.api.cdr.alncorp.com/api/',
    cmReadApiUrl: 'https://cmreadapi.cdr.alncorp.com/api/',
    milanaCentralApiUrl: 'https://milanacentral.api.cdr.alncorp.com/api/',
    milanaAuthorizeApiUrl: 'https://milanaauthorize.api.cdr.alncorp.com',
    aptrinsicKey: 'AP-WTSHNIJNTFRB-2-2',
    AderantAdminUserRole: 'UserManagement.Admin'
};
